import { cn } from '../lib/utils';

export function LiveIndicator({ className }) {
  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
      <span className="text-[10px] uppercase tracking-wider font-bold text-emerald-400">
        LIVE
      </span>
    </div>
  );
}

export function StatusBadge({ status, className }) {
  const statusConfig = {
    open: { color: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30', label: 'OPEN' },
    suspended: { color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30', label: 'SUSPENDED' },
    closed: { color: 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30', label: 'CLOSED' },
    settled: { color: 'bg-blue-500/20 text-blue-400 border-blue-500/30', label: 'SETTLED' },
  };

  const config = statusConfig[status] || statusConfig.closed;

  return (
    <span 
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-[10px] uppercase font-bold tracking-wider border rounded-full",
        config.color,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {status === 'open' && (
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 mr-1.5 animate-pulse" />
      )}
      {config.label}
    </span>
  );
}
